import { Button } from "@mui/material";
import { useDarkMode } from "../../../contexts/useDarkModeContext";

function MarketingGeniusButton({
  children,
  alignSelf = "",
  featuredCardButtonDarkmodeBg = "#e5e5e5",
  featuredCardButtonDarkmodeColor = "#000000",
  borderRadius = "10px",
  bgColor = "#e5e5e5",
  py = "5px",
  px = "20px",
}) {
  const { darkMode } = useDarkMode();
  return (
    <Button
      variant="contained"
      sx={{
        alignSelf: alignSelf,
        borderRadius: borderRadius,
        // minWidth: "auto",
        width: "auto",
        textTransform: "none",
        bgcolor: darkMode ? `${featuredCardButtonDarkmodeBg}` : `${bgColor}`,
        color: darkMode ? `${featuredCardButtonDarkmodeColor}` : "#000000",
        boxShadow: "none",
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "26px",
        py: `${py}`,
        px: `${px}`,
        mt: "10px",
        "&:hover": {
          bgcolor: darkMode ? `${featuredCardButtonDarkmodeBg}` : "#e5e5e5",
          boxShadow: "none",
        },
        "&:active": {
          bgcolor: darkMode ? `${featuredCardButtonDarkmodeBg}` : "#e5e5e5",
          boxShadow: "none",
        },
        "&:focus": {
          outline: "none",
          boxshadow: "none",
        },
        "& .MuiButtonBase-root": {
          width: "auto !important",
          minWidth: "0px !important",
          padding: "0px",
          boxshadow: "none",
        },
      }}
    >
      {children}
    </Button>
  );
}

export default MarketingGeniusButton;
